/* eslint-disable import/prefer-default-export */
/* eslint-disable react/no-danger */
import React from 'react';
import styled, { css } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import { Button } from '../Elements/Button';

const DialogBoxAnimation = {
  hidden: {
    opacity: 0,
    scale: 0.92,
  },
  open: {
    opacity: 1,
    scale: 1,
    transition: {
      ease: 'easeInOut',
      duration: 0.22,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.92,
    transition: {
      ease: 'easeInOut',
      duration: 0.15,
    },
  },
};

const Root = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Scrim = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const DialogContainer = styled(motion.div)`
  position: relative;
  z-index: 3;
  background-color: ${({ theme }) => theme.defaultSurfaceE24};
  width: 17.5rem;
  box-shadow: ${({ theme }) => theme.elevation24};
  border-radius: ${({ theme }) => theme.borderRadius};
  @media (min-width: 37rem) {
    width: 35rem;
  }

  .dialog__message-container {
    padding: 1.25rem 1.5rem 1.25rem;
  }

  .dialog__title {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.onLightColorHighEmphasis};
  }

  .dialog__message {
    color: ${({ theme }) => theme.onLightColorMediumEmphasis};
  }
`;

const ButtonGroup = styled.div`
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  display: flex;
  justify-content: flex-end;

  .dialog__primary-button {
    margin-left: 0.5rem;
  }

  ${(props) => {
    if (props.stackedButtons) {
      return css`
        display: grid;
        justify-items: end;
        .dialog__primary-button {
          margin-top: 0.75rem;
        }
      `;
    }
    return css`
      display: flex;
      justify-content: flex-end;
    `;
  }}
`;

export const Dialog = ({
  open,
  dialogTitle,
  dialogMessage,
  dialogPrimaryActionTitle,
  dialogPrimaryAction,
  dialogSecondaryActionTitle,
  dialogSecondaryAction,
  closeFunc,
  stackedButtons,
}) => {
  //

  const primaryAction = () => {
    dialogPrimaryAction();
    closeFunc();
  };

  const secondaryAction = () => {
    dialogSecondaryAction();
    closeFunc();
  };

  return (
    <AnimatePresence>
      {open && (
        <Modal open aria-labelledby="modal for dialog" aria-describedby="modal for dialog">
          <Root>
            <Scrim />
            <DialogContainer initial="hidden" animate="open" exit="exit" variants={DialogBoxAnimation}>
              <div className="dialog__message-container">
                <div className="roboto-text-lg dialog__title">{dialogTitle}</div>
                <p className="roboto-text-base roboto-text-base--body dialog__message">{dialogMessage}</p>
              </div>
              <ButtonGroup stackedButtons={stackedButtons}>
                <div>
                  <Button modifiers={['text', 'small']} onClick={secondaryAction}>
                    {dialogSecondaryActionTitle}
                  </Button>
                </div>
                <div className="dialog__primary-button">
                  <Button modifiers={['text', 'small']} onClick={primaryAction}>
                    {dialogPrimaryActionTitle}
                  </Button>
                </div>
              </ButtonGroup>
            </DialogContainer>
          </Root>
        </Modal>
      )}
    </AnimatePresence>
  );
};

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  stackedButtons: PropTypes.bool,
  dialogTitle: PropTypes.string.isRequired,
  dialogMessage: PropTypes.string.isRequired,
  closeFunc: PropTypes.func.isRequired,
  dialogPrimaryActionTitle: PropTypes.string,
  dialogPrimaryAction: PropTypes.func,
  dialogSecondaryActionTitle: PropTypes.string,
  dialogSecondaryAction: PropTypes.func,
};

Dialog.defaultProps = {
  stackedButtons: false,
  dialogPrimaryAction: () => {},
  dialogSecondaryAction: () => {},
  dialogPrimaryActionTitle: '',
  dialogSecondaryActionTitle: '',
};
